module.exports = __webpack_public_path__ + "img/pic_location_Ecua_Quito.352894f8.png";